import { VehicleClass } from 'app/utility/enums';
import { ActivatedRoute } from '@angular/router';
import { VehicleService } from 'app/services/vehicle.service';
import { ContactResultModel } from 'app/models/dms/contact.model';
import { LookupInternalModel, LookupModel } from 'app/models/shared/lookup.model';
import { ContactService } from 'app/services/contact.service';
import { FieldGroupModel } from 'app/models/shared/fieldGroup.model';
import { FieldModel } from 'app/models/shared/field.model';
import { ModalController, AlertController, LoadingController, PopoverController, ActionSheetController, Platform } from '@ionic/angular';
import { VehicleModel, VehicleFeaturesModel } from 'app/models/dms/vehicle.model';
import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';

import { GeneralService } from 'app/services/general.service';

import { LookupInternalCollection, SalesStatus } from 'app/utility/enums';

import { VehicleStatusModel } from 'app/models/dms/vehicleStatus.model';
import { ListItemModel } from 'app/models/shared/listItem.model';
import { ContactModel } from 'app/models/dms/contact.model';
import { Constants } from 'app/utility/constants';
import { TabModel } from 'app/models/shared/tab.model';
import { UserService } from 'app/services/user.service';
import { Title } from '@angular/platform-browser';
import { EditorPageComponent } from 'app/components/shared/editor-page/editor-page.component';
import { StorageService } from 'app/services/storage.service';
import { StringHelper } from 'app/utility/stringhelper';

@Component({
    selector: 'app-vehicle-features',
    templateUrl: './vehicle-features.component.html',
    styleUrls: ['./vehicle-features.component.scss'],
    standalone: false
})
export class VehicleFeaturesComponent extends EditorPageComponent implements OnInit
{

	@Input() vehicle: VehicleModel;
	editVehicle: VehicleModel;

	public statuses: ListItemModel[];
	public suppliers: ListItemModel[];
	statusLookups: LookupInternalModel[];

	constructor(
		public contactService: ContactService,
		public generalService: GeneralService, //for lookups - todo: remove
		public userService: UserService,
		public vehicleService: VehicleService,
		public route: ActivatedRoute,
		public titleService: Title,
		public storage: StorageService,
		public alertController: AlertController,
		public popoverController: PopoverController,
		public actionSheetController: ActionSheetController,
		public loadingController: LoadingController,
		protected cd: ChangeDetectorRef,
		public modalController: ModalController,
		public platform: Platform
	)
	{
		super(userService, route, titleService, storage, alertController, popoverController, actionSheetController, loadingController, cd, platform);
		this.editActive = true;
	}

	skeleton: boolean = false;
	vehicleFeatures: VehicleFeaturesModel;
	mcOnInit()
	{
		// console.log(this.vehicle);
		this.setEdit(true);
		this.skeleton = true;
		this.editVehicle = Object.create(this.vehicle);
		this.vehicleFeatures = new VehicleFeaturesModel();
		this.vehicleFeatures.interiorFeatureIds = this.vehicle.vehicleInterior.interiorFeatureIds;
		this.vehicleFeatures.exteriorFeatureIds = this.vehicle.vehicleExterior.exteriorFeatureIds;
		this.vehicleFeatures.mechanicalFeatureIds = this.vehicle.vehicleMechanical.mechanicalFeatureIds;
		this.activeSegment = 'features';
		this.getLookups();
	}


	//override from parent
	public ionViewDidEnter()
	{
	}


	public setupFieldGroups(makeDirty: boolean = false): void
	{
		this.fieldGroupTabs = [];
		var field_groups = this.getFieldGroups("features");
		this.fieldGroupTabs.push(new TabModel("Features", this.vehicleFeatures, field_groups, makeDirty, "features", "", true, true));
		this.skeleton = false;
	}

	async presentAlert(title: string, message: string, back: boolean = false)
	{
		this.userService.presentAlert(title, message, back);
	}

	public getFieldGroups(groupId: string): FieldGroupModel[]
	{

		var field_groups = [];
		switch (groupId)
		{
			case "features":
				var field_group = new FieldGroupModel("Vehicle Features");

				if (this.vehicle.vehicleClass == VehicleClass.Caravan ||
					this.vehicle.vehicleClass == VehicleClass.Machine ||
					this.vehicle.vehicleClass == VehicleClass.Motorhome ||
					this.vehicle.vehicleClass == VehicleClass.PassengerVehicle ||
					this.vehicle.vehicleClass == VehicleClass.Boat)
				{
					field_group.addField(new FieldModel('Interior Features', this.vehicleFeatures.interiorFeatureIds, 'lookups', 'interiorFeatureIds', true, false, this.vehicle.vehicleInterior.interiorFeatureLookups, '', this.vehicle.vehicleClass));
				}

				field_group.addField(new FieldModel('Exterior Features', this.vehicleFeatures.exteriorFeatureIds, 'lookups', 'exteriorFeatureIds', true, false, this.vehicle.vehicleExterior.exteriorFeatureLookups, '', this.vehicle.vehicleClass));

				if (this.vehicle.vehicleClass == VehicleClass.Boat || this.vehicle.vehicleClass == VehicleClass.GoodsVehicle || this.vehicle.vehicleClass == VehicleClass.Machine || this.vehicle.vehicleClass == VehicleClass.Motorcycle || this.vehicle.vehicleClass == VehicleClass.Motorhome || this.vehicle.vehicleClass == VehicleClass.PassengerVehicle)
				{
					field_group.addField(new FieldModel('Mechanical Features', this.vehicleFeatures.mechanicalFeatureIds, 'lookups', 'mechanicalFeatureIds', true, false, this.vehicle.vehicleMechanical.mechanicalFeatureLookups, '', this.vehicle.vehicleClass));
				}

				field_groups.push(field_group);
				break;
		}
		return field_groups;
	}


	protected getLookups(): void
	{
		this.setupFieldGroups();
	}


	isDirty: boolean = false;
	async cancelModal()
	{
		if (this.isDirty)
		{
			//prompt user to save
			const alert = await this.alertController.create({
				header: "Unsaved changes",
				message: "Some data has changed. Do you want to close without saving?",
				buttons: [
					{
						text: 'Cancel',
						role: 'cancel',
						cssClass: 'primary',
						handler: () =>
						{
							//do nothing
							return;
						}
					},
					{
						text: 'OK',
						cssClass: 'danger',
						handler: () =>
						{
							this.dismissTheModal(false);
						}
					}
				]
			});

			await alert.present();
		}
		else
		{
			this.dismissTheModal(false);
		}
	}

	async dismissTheModal(save: boolean)
	{
		if (save)
		{

			this.syncFormWithObject();

			const loading = await this.loadingController.create({
				message: 'Saving',
				duration: 60000
			});
			await loading.present();


			this.vehicle.vehicleInterior.interiorFeatureIds = this.vehicleFeatures.interiorFeatureIds;
			this.vehicle.vehicleExterior.exteriorFeatureIds = this.vehicleFeatures.exteriorFeatureIds;
			this.vehicle.vehicleMechanical.mechanicalFeatureIds = this.vehicleFeatures.mechanicalFeatureIds;

			this.vehicleService.saveVehicle(this.vehicle).subscribe({
				next: x =>
				{
					this.vehicle = x;
					loading.dismiss();
					// Dismiss the top modal returning some data object
					this.modalController.dismiss({
						'result': {
							save: true,
							vehicle: x
						}
					});
				},
				error: err =>
				{
					loading.dismiss();
					this.handleError(err);
				}
			});

		}
		else
		{
			// Dismiss the top modal returning some data object
			this.modalController.dismiss({
				'result': {
					save: save
				}
			});
		}
	}

	async handleFieldChangedAdditional(ev: any)
	{
		if (!(ev.detail && ev.detail.value && ev.detail.id)) return;
		switch (ev.detail.id)
		{

			// case "vehicleStatusId":
			// 	var newStatus = this.statusLookups.filter(x => x.id == ev.detail.value).shift();

			// 	if (newStatus)
			// 	{
			// 		this.editVehicle.vehicleAdmin.vehicleStatus = newStatus;
			// 		this.editVehicle.vehicleAdmin.vehicleStatusId = ev.detail.value;
			// 	}
			// 	setTimeout(() =>
			// 	{
			// 		this.setupFieldGroups();
			// 	}, 50);
			// 	break;
			// case "vehicleStatusDesc":
			// 	this.editVehicle.vehicleAdmin.vehicleStatusDesc = ev.detail.value;
			// 	break;
			// case "vehicleStatusSupId":
			// 	this.editVehicle.vehicleAdmin.vehicleStatusSupId = ev.detail.value;
			// 	break;
		}
	}



	public numberWithCommas(x: any): string
	{
		return StringHelper.numberWithCommas(x);
	}

}
